import React, { useEffect, useState } from 'react';
import { translate } from '../../../utils/Common';
import { SegmentedControl } from '@/components/ui/segmented-control';

// Componente funcional
const TipoPaqueteSwitch = ({ idTipoPaquete, setIdTipoPaquete }) => {

    const [typeTransaction, setTypeTransaction] = useState(3);

    // 1 = regular only, 2 = returns only, 3 = both.
    const OPTIONS = {
        regular: { value: 2, label: translate("global.status.typePackage.regular") },
        return: { value: 3, label: translate("global.registerPackage.return") },
    };

    const availableOptions = () => {
        switch (typeTransaction) {
            case 1:
                return [OPTIONS.regular];
            case 2:
                return [OPTIONS.return];
            case 3:
                return [OPTIONS.regular, OPTIONS.return];
            default:
                return [];
        }
    };

    const handleSwitchChange = (id) => {
        setIdTipoPaquete(id);
    };

    useEffect(() => {

        const getTypeTransaction = async () => {
            const typeTransaction = JSON.parse(sessionStorage.getItem('user'))?.typeTransactionId;
            setTypeTransaction(typeTransaction);

            switch (typeTransaction) {
                case 1:
                    handleSwitchChange(2);
                    break;
    
                    case 2:
                        handleSwitchChange(3);
                        break;
    
                        case 3:
                            handleSwitchChange(2);
                            break;
            
                default:
                    break;
            }

          };
        

        getTypeTransaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    

    return (
        <SegmentedControl
            name="tipoPaquete"
            label={translate("global.typeOfPackage")}
            value={idTipoPaquete}
            onChange={handleSwitchChange}
            options={availableOptions()}
        />
    );
};

export default TipoPaqueteSwitch;
